import store from "@/store/index.js";
import { candidateHttp } from "@/plugins/axios.js";
/**
 * Load session + token after Mod Proctor / Proctor Exam redirect (one-time URL consumed server-side).
 * Called from main.js before the router loads (see bootstrap there).
 */
export async function fetchProctoredAssessmentSession(token) {
    const locale = store.state.translatables?.locale || "en";
    const url = window.endpoint(
        `/sanctum/proctored-assessment/${token}?locale=${locale}`,
    );
    const { data } = await candidateHttp.get(url);
    store.commit("setUser", data.user);
    store.commit("setAssessment", data.assessment);
    store.commit("setToken", data.token);
    store.commit("setLoggedInAtTime", new Date().toUTCString());
    candidateHttp.defaults.headers.common["Authorization"] =
        "Bearer " + data.token;
    return data;
}
